<template>
  <div class="addclient">
      <div class="card-block">
          <form v-if="!waitForData" @submit.prevent="submitForm">
            <div class="row justify-content-center">
              <div class="form-group col-md-12">
                <label for="citizenshipGov">Státní příslušnost (občanství):</label>
                <div class="input-group">
                  <select v-model="client.citizenship" class="form-control" aria-describedby="citizenshipGovHelp" id="citizenshipGov" data-testid="registration-citizenship">
                    <option v-for="row in citizenship" v-bind:value="row.id">{{ row.name_cz }} - {{ row.code }} - {{ row.name_en }}</option>
                  </select>
                  <small id="citizenshipError" class="form-text text-danger" v-if="clientError.citizenship">{{ clientError.citizenship.message }}</small>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-12">
                <label for="personalid">Rodné číslo:</label>
                <input v-model.trim="client.p_i_n" type="text" class="form-control" aria-describedby="personalidHelp" id="personalid" data-testid="registration-pin" @change="clientPINChanged">
                <div v-if="pinDecodeWarning !== null" data-testid="registration-pin-warnings">
                  <div v-for="(warning, index) in pinDecodeWarning">
                    <small class="form-text text-danger">{{ warning.text }}</small>
                    <template v-if="index === 'duplicate'">
                      <small v-for="client in warning.clients" class="form-text text-danger"> - {{ client.full_name }}</small>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-6">
                <label for="firstname">Jméno:</label>
                <input v-model="client.first_name" type="text" class="form-control" aria-describedby="firstnameHelp" id="firstname" data-testid="registration-first-name">
                <small id="firstnameError" class="form-text text-danger" data-testid="registration-first-name-error" v-if="clientError.firstname">{{ clientError.firstname.message }}</small>
              </div>
              <div class="form-group col-md-6">
                <label for="lastname">Příjmení:</label>
                <input v-model="client.last_name" type="text" class="form-control" aria-describedby="lastnameHelp" id="lastname" data-testid="registration-last-name">
                <small id="lastnameError" class="form-text text-danger" data-testid="registration-last-name-error" v-if="clientError.lastname">{{ clientError.lastname.message }}</small>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-6">
                <label for="gender">Pohlaví:</label>
                <div class="input-group">
                  <select v-model="client.gender" class="form-control" aria-describedby="genderHelp" id="gender" data-testid="registration-gender" :disabled="birthDateCalculated">
                    <option value="male">muž</option>
                    <option value="female">žena</option>
                    <option value="unknown">nezjištěno</option>
                  </select>
                  <small id="genderError" class="form-text text-danger" v-if="clientError.gender">{{ clientError.gender.message }}</small>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label for="birthdate">Datum narození:</label>
                <input v-model="client.birth_date" type="text" class="form-control" aria-describedby="birthdateHelp" id="birthdate" data-testid="registration-birth-date" :disabled="birthDateCalculated">
                <small id="birthdateError" class="form-text text-danger" v-if="clientError.birthdate">{{ clientError.birthdate.message }}</small>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-12">
                <label for="insuranceCompany">Zdravotní pojišťovna:</label>
                <multiselect id="insuranceCompany"
                             data-testid="registration-insurance-company"
                             v-model="selectedInsuranceCompany"
                             props="options"
                             :options="insuranceCompanies"
                             track-by="name"
                             label="name"
                             placeholder="vybrat pojišťovnu"
                             :option-height="104"
                             open-direction="down"
                             :custom-label="customLabel"
                             :show-labels="false"
                             TagPlaceholder=""
                             :allow-empty="true"
                             :disabled="insuranceFound"
                             selectLabel="">
                  <template slot="option" scope="props">
                    <span :data-testid="'registration-insurance-company-option-' + props.option.code">{{ customLabel(props.option) }}</span>
                  </template>
                </multiselect>
                <!--<small id="personalidError" class="form-text text-danger" v-if="clientError.pin">{{ clientError.pin.message }}</small>-->
                <label for="insuranceType" class="ml-sm-2 mr-sm-2">Druh: </label>
                <select class="form-control" v-model="client.insurance.type" id="insuranceType" data-testid="registration-insurance-type" :disabled="insuranceFound">
                  <option v-for="n in 4" v-bind:value="n">{{ n }} - {{ n | insuranceTypeIntToName }}</option>
                </select>
              </div>
            </div>
            <div v-if="client.citizenship!==1" class="row justify-content-center">
              <div class="form-group col-md-12">
                <label for="insuranceNumber">Číslo pojištěnce:</label>
                <input v-model="client.nationality" type="text" class="form-control" aria-describedby="insuranceNumberHelp" id="insuranceNumber" data-testid="registration-insurance-number">
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="form-group col-md-12 text-center">

                <button v-if="decodePinPending" class="btn btn-primary disabled" disabled="disabled"><i class="fa fa-spinner fa-pulse fa-fw"></i> Čekám</button>
                <button v-else-if="clientPending === false" type="submit" class="btn btn-primary" data-testid="registration-submit">Zaregistrovat klienta</button>
                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
              </div>
            </div>
          </form>
        <div  v-if="waitForData" class="row justify-content-around">
          <div class="">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        // client
        clientError: {},
        clientPending: false,
        client: {
          gender: 'unknown',
          first_name: '',
          last_name: '',
          p_i_n: '',
          citizenship: 1,
          birth_date: '',
          // birthplace: ''
          birthplace: '',
          insurance: {
            company_code: '',
            type: 1
          }
        },
        citizenshipError: {},
        birthDateCalculated: false,
        insuranceFound: false,
        // others
        setting: require('../../../variables.js'),
        clientid: '',
        waitForResponse: false,
        waitForData: false,
        decodePinPending: false,
        message: '',
        submited: '',
        countries: [],
        citizenship: [],
        healthinsurance: [],
        pinDecodeError: false,
        pinDecodeWarning: false,
        // insurace block
        insuranceCompanies: {},
        insuranceCompaniesError: {},
        selectedInsuranceCompany: null,
        insurancePending: false,
        insuranceError: {},
        insurance: {
          insurancecompany: null,
          valid_from: '',
          type: 1
        }
      }
    },
    methods: {
      submitForm () {
        this.postClient()
      },
      getCitizenship () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'citizenship').then(response => {
          this.citizenship = response.data
          // this.useGovData = true
          this.waitForData = false
        }).catch(error => {
          console.log(error.response)
          this.citizenshipError = error.response.data.errors
          this.waitForData = false
        })
      },
      getInfoDecodePIN () {
        this.pinDecodeError = false
        this.decodePinPending = true
        this.insuranceFound = false
        this.pinDecodeWarning = null
        this.birthDateCalculated = false
        this.insurance = {
          insurancecompany: null,
          valid_from: '',
          type: 1
        }
        this.$http.get(this.setting.hostname + 'validatepin', {params: {pin: this.client.p_i_n}}).then(response => {
          if (response.data.birth_date) {
            this.client.gender = response.data.gender
            this.client.birth_date = response.data.birth_date
            this.birthDateCalculated = true
          }

          if (response.data.insurance !== null) {
            this.selectInsuranceCompany(response.data.insurance.company)
            this.client.insurance.type = response.data.insurance.type
            this.client.insurance.company_code = response.data.insurance.company
            this.insuranceFound = true
          }

          this.pinDecodeError = false
          this.message = ''
          this.pinDecodeWarning = response.data.warning
          // this.useGovData = true
          this.decodePinPending = false
        }).catch(error => {
          this.pinDecodeError = error.response.data.error
          this.decodePinPending = false
        })
      },
      postClient () {
        this.clientPending = true

        let client = this.client
        client.citizenship_id = this.client.citizenship
        delete client.citizenship

        this.$http.post(this.setting.hostname + 'client', client, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.clientid = response.data.id
          this.clientPending = false
          this.$emit('client-id', this.clientid)
          this.$emit('completed-step', 1)
          // this.$router.push({name: 'AddAddress', params: { clientid: response.data.id }})
          // this.$route.push()
        }).catch(error => {
          this.clientError = error.response.data.errors
          this.clientPending = false
        })
      },
      selectInsuranceCompany (code) {
        for (let index = 0; index < this.insuranceCompanies.length; index++) {
          if (code === null && this.insuranceCompanies[index].code === '---') {
            this.selectedInsuranceCompany = this.insuranceCompanies[index]
            continue
          }
          if (this.insuranceCompanies[index].code === code) {
            this.selectedInsuranceCompany = this.insuranceCompanies[index]
            continue
          }
        }
      },
      getInsuranceCompanies () {
        this.waitForData = true
        this.$http.get(this.setting.hostname + 'insurance_companies').then(response => {
          this.insuranceCompanies = response.data
          this.waitForData = false
        }).catch(error => {
          this.insuranceCompaniesError = error.response.data.errors
          this.waitForData = false
        })
      },
      customLabel ({ code, name }) {
        return `${code} – ${name}`
      }
      /* putClient () {
        this.waitForResponse = true
        this.submited = 'yeaaa'
        this.$http.put(this.setting.hostname + 'client/' + this.clientid, this.client, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.clientid = response.data.id
        }, response => {
          this.errors = response.data.errors
          this.waitForResponse = false
        })
      }, */
    },
    beforeMount () {
      this.getInsuranceCompanies()
      this.getCitizenship()
    },
    watch: {
      'client.p_i_n': function (val, oldVal) {
        if (this.client.citizenship === 1) {
          this.client.p_i_n = val.replace(/\D/g, '')

          if (val !== this.client.p_i_n) {
            return
          }

          if (val.length < 9) {
            this.message = 'příliš krátké'
            this.client.gender = 'unknown'
            this.client.birth_date = ''
          } else if (val.length > 10) {
            this.message = 'příliš dlouhé'
            this.client.gender = 'unknown'
            this.client.birth_date = ''
          } else {
            this.message = '<i class="fa fa-spinner fa-pulse fa-fw"></i>' + 'načítám'
            setTimeout(() => {
              this.getInfoDecodePIN()
            }, 500)
          }
        }
      },
      'selectedInsuranceCompany': function (val) {
        this.client.insurance.company_code = val.code
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.icon-male {
  color: dodgerblue;
  font-weight: bold;
}

.icon-female {
  color: deeppink;
  font-weight: bold;
}

.icon-genderless {
  color: #ccc;
  font-weight: bold;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > td, .table > tfoot > tr > td {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/views/Registration/components/RegistrationClient.vue?597b510d